import useAuth from '../../hooks/useAuth';
import PreSaleVisitDetail from './PreSaleVisitDetail';
import ProperPreSaleVisitDetail from './ProperPreSaleVisitDetail';

// El Proper usa un detalle con sólo sus acciones (endpoints de proper); el
// resto de usuarios internos, el detalle completo.
const PreSaleVisitDetailRoute = () => {
  const { getUserRealm } = useAuth();
  return getUserRealm().toLowerCase() === 'proper' ? (
    <ProperPreSaleVisitDetail />
  ) : (
    <PreSaleVisitDetail />
  );
};

export default PreSaleVisitDetailRoute;
